import { createApp } from 'vue'
import App from './App.vue'
import 'normalize.css/normalize.css'
import 'view-ui-plus/dist/styles/viewuiplus.css'
import './styles/brand-viewui.css' // view-ui-plus 品牌主题覆盖层(Neon Chrome)
import './styles/main.styl' // 公用样式须在 router 前导入
import './styles/tokens.css'
import './styles/cards.css'
import './styles/editor-table.css'
import './styles/mobile-content-detail.css'
import './styles/search-filter.css' // 搜索筛选区全局布局统一(见文件头注释)
import './styles/mobile-swipe-tabs.css' // 移动端多tab左右滑切换的面板滑入动画
import './styles/markdown-body.css' // markdown 渲染样式(v-html 内容须全局作用域,见文件头注释)
import router from './router/index'
import { setupIView } from './plugins/iview'
import { setupVant } from './plugins/vant'
import wj from './plugins/wjtools'
import * as api from './api'

let wangEditorBootReady = false
const initWangEditorBoot = async () => {
  if (wangEditorBootReady) return
  wangEditorBootReady = true
  try {
    const [
      { Boot },
      { AIContinueMenu },
      { AIImageMenu },
      { AiImageEditMenu },
      { AIRewriteMenu },
      { SectionAiRewriteMenu },
      { SmartImageMenu },
      { ImageEditMenu },
      { CopyToLibraryMenu }
    ] = await Promise.all([
      import('@wangeditor-next/editor'),
      import('./plugins/AIContinueMenu'),
      import('./plugins/AiImageMenu'),
      import('./plugins/AiImageEditMenu'),
      import('./plugins/AiRewriteMenu'),
      import('./plugins/SectionAiRewriteMenu'),
      import('./plugins/SmartImageMenu'),
      import('./plugins/ImageEditMenu'),
      import('./plugins/CopyToLibraryMenu'),
      import('@wangeditor-next/editor/dist/css/style.css')
    ])

    Boot.registerMenu({
      key: 'aiContinue',
      factory() {
        return new AIContinueMenu()
      }
    })
    Boot.registerMenu({
      key: 'aiImage',
      factory() {
        return new AIImageMenu()
      }
    })
    Boot.registerMenu({
      key: 'smartImage',
      factory() {
        return new SmartImageMenu()
      }
    })
    Boot.registerMenu({
      key: 'imageEdit',
      factory() {
        return new ImageEditMenu()
      }
    })
    Boot.registerMenu({
      key: 'aiImageEdit',
      factory() {
        return new AiImageEditMenu()
      }
    })
    Boot.registerMenu({
      key: 'aiRewrite',
      factory() {
        return new AIRewriteMenu()
      }
    })
    Boot.registerMenu({
      key: 'sectionAiRewrite',
      factory() {
        return new SectionAiRewriteMenu()
      }
    })
    Boot.registerMenu({
      key: 'copyToLibrary',
      factory() {
        return new CopyToLibraryMenu()
      }
    })
  } catch (err) {
    console.error('[wangEditor] boot init failed:', err)
  }
}
initWangEditorBoot()

const app = createApp(App)

setupIView(app)
setupVant(app)

app.config.globalProperties.$wj = wj
app.config.globalProperties.$api = api

app.use(router)
app.mount('#app')
